import { render } from "./LeagueStanding.vue?vue&type=template&id=b5d5df14&scoped=true"
import script from "./LeagueStanding.vue?vue&type=script&lang=js"
export * from "./LeagueStanding.vue?vue&type=script&lang=js"

import "./LeagueStanding.vue?vue&type=style&index=0&id=b5d5df14&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d5df14"]])

export default __exports__